import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-white/80 border-t border-slate-200 py-10 sm:py-12 mt-16 sm:mt-20 relative z-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {/* Brand column */}
          <div className="sm:col-span-2">
            <Link to="/program" className="inline-flex items-center space-x-2 mb-4 group">
              <div className="bg-[#f97316] w-9 h-9 rounded-md flex items-center justify-center group-hover:bg-[#ea580c] transition-colors shrink-0">
                <span className="text-white font-serif italic font-bold text-xl leading-none select-none">i</span>
              </div>
              <span className="text-lg sm:text-xl font-bold font-display text-slate-900 group-hover:text-primary transition-colors">
                inTouch<span className="text-secondary">.</span>
              </span>
            </Link>
            <p className="text-slate-500 text-sm leading-relaxed max-w-sm">
              Connecting people through innovative technology and interactive
              experiences. We build the future of engagement.
            </p>
            {/* Social icons row */}
            <div className="flex items-center space-x-3 mt-5">
              {[
                { icon: FiIcons.FiLinkedin, href: 'https://na.linkedin.com/company/intouch-interactive-marketing', label: 'LinkedIn' },
                { icon: FiIcons.FiFacebook, href: 'https://www.facebook.com/intouch.interactive.marketing/', label: 'Facebook' },
                { icon: FiIcons.FiInstagram, href: 'https://www.instagram.com/intouchmarketingnam/?hl=en', label: 'Instagram' },
              ].map(({ icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-lg bg-slate-100 hover:bg-primary flex items-center justify-center text-slate-500 hover:text-white transition-all"
                  aria-label={label}
                >
                  <SafeIcon icon={icon} className="text-base" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-slate-900 font-semibold mb-3 sm:mb-4 text-sm uppercase tracking-wider">
              Quick Links
            </h3>
            <ul className="space-y-2.5 text-sm text-slate-500">
              <li>
                <Link
                  to="/program"
                  className="hover:text-primary transition-colors inline-flex items-center min-h-[32px]"
                >
                  Event Program
                </Link>
              </li>
              <li>
                <Link
                  to="/intouch"
                  className="hover:text-primary transition-colors inline-flex items-center min-h-[32px]"
                >
                  Our Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-slate-900 font-semibold mb-3 sm:mb-4 text-sm uppercase tracking-wider">
              Contact
            </h3>
            <ul className="space-y-3 text-sm text-slate-500">
              <li className="flex items-center space-x-2.5 min-h-[32px]">
                <SafeIcon icon={FiIcons.FiMail} className="text-primary shrink-0" />
                <a href="mailto:info@intouch.com.na" className="hover:text-primary transition-colors">info@intouch.com.na</a>
              </li>
              <li className="flex items-center space-x-2.5 min-h-[32px]">
                <SafeIcon icon={FiIcons.FiPhone} className="text-primary shrink-0" />
                <a href="tel:+2646130959" className="hover:text-primary transition-colors">(+264) 61 309 591</a>
              </li>
              <li className="flex items-start space-x-2.5 min-h-[32px]">
                <SafeIcon icon={FiIcons.FiMapPin} className="text-primary shrink-0 mt-0.5" />
                <span>7 Ruhr Street, Northern Industria, Windhoek</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider + Copyright */}
        <div className="border-t border-slate-200 mt-10 sm:mt-12 pt-6 sm:pt-8 text-center text-xs sm:text-sm text-slate-500">
          &copy; {new Date().getFullYear()} inTouch Interactive Technologies. All
          rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
